import React, { Component } from 'react'
import { Row, Col, Card } from "react-bootstrap";
import { __, forceSatoshiFormat } from "../../../../Helper";
import storage from "../../../../Storage";

class Table extends Component {
	constructor(props) {
		super(props);
		this.state = {
			amount: forceSatoshiFormat(storage.getKey('lam') ? storage.getKey('lam') : .00000010),
			scoreName: null
		}
	}

	componentDidMount() {
		this.props.engine.on('update_table', (score,) => {
			this.setState({ scoreName: __.upperCase(score) })
		})

		this.props.engine.on('update_table_amount', (amount) => {
			this.setState({ amount: parseFloat(amount) })
		})
	}

	render() {
		const { scoreName } = this.state;
		return (
			<>
				<Row className="total-payment game-fonts videopoker-table" >
					<Row md={5} lg={5} sm={5} className={'col-12 col-sm-5 col-md-5 '} style={{margin:"1px"}}  >
						<Row>
							<Row sm={12} md={12} style={{width:"100%",backgroundColor:"#222328",padding:"7px 0px"}}>
							<Col style={{display:"flex",gap:"3px",alignItems:"center"}}  className={(scoreName === 'ROYAL FLUSH') ? ' active col-6 ' : ' col-6 '}>
							<span>
							<img src='/assets/images/poker-table-dot.webp' style={{width:"12px",height:"12px"}}/>
							</span>
							<span className='game-fonts'>	ROYAL FLUSH</span>
							</Col>
							<Row className={(scoreName === 'ROYAL FLUSH') ? ' active col-6 ' : ' col-6'}>
								<span className="text-warning">8x - {forceSatoshiFormat(this.state.amount * 8)}</span>
							</Row>
							</Row>
							<Row sm={12} md={12} style={{width:"100%",backgroundColor:"#222328",padding:" 7px 0px"}}>
							<Col style={{display:"flex",gap:"3px",alignItems:"center"}} className={(scoreName === 'STRAIGHT FLUSH') ? ' active col-6 ' : ' col-6 '}>
							<span>
							<img src='/assets/images/poker-table-dot.webp' style={{width:"12px",height:"12px"}}/>
							</span>
								<span className='game-fonts'>
								STRAIGHT FLUSH
								</span>
							</Col>
							<Row className={(scoreName === 'STRAIGHT FLUSH') ? ' active col-6 ' : ' col-6'}>
								<span className="text-warning">4x - {forceSatoshiFormat(this.state.amount *4)}</span>
							</Row>
							</Row>
							<Row sm={12} md={12} style={{width:"100%",backgroundColor:"#222328",padding:" 7px 0px"}}>
							<Col style={{display:"flex",gap:"3px",alignItems:"center"}} className={(scoreName === 'FOUR OF A KIND') ? ' active col-6 ' : ' col-6'}>
							<span>
							<img src='/assets/images/poker-table-dot.webp' style={{width:"12px",height:"12px"}}/>
							</span>
								<span className='game-fonts'>
								4 OF A KIND
								</span>
							</Col>
							<Row  className={(scoreName === 'FOUR OF A KIND') ? ' active col-6 ' : ' col-6'}>
								<span className="text-warning">2x - {forceSatoshiFormat(this.state.amount * 2)}</span>
							</Row>
							</Row>

							<Row sm={12} md={12} style={{width:"100%",backgroundColor:"#222328",padding:" 7px 0px"}}>
							<Col style={{display:"flex",gap:"3px",alignItems:"center"}} className={(scoreName === 'FULL HOUSE') ? ' active col-6 ' : ' col-6 '}>
							<span>
							<img src='/assets/images/poker-table-dot.webp' style={{width:"12px",height:"12px"}}/>
							</span>
								<span className='game-fonts'>
								FULL HOUSE
								</span>
							</Col>
							<Row sm={12} md={12} className={(scoreName === 'FULL HOUSE') ? ' active col-6 ' : ' col-6 '}>
								<span  className="text-warning">1.9x - {forceSatoshiFormat(this.state.amount * 1.9)}</span>
							</Row>
							</Row>

							<Row sm={12} md={12} style={{width:"100%",backgroundColor:"#222328",padding:" 7px 0px"}}>
							<Col style={{display:"flex",gap:"3px",alignItems:"center"}} className={(scoreName === 'FLUSH') ? ' active col-6 ' : ' col-6 text-left'}>
							<span>
							<img src='/assets/images/poker-table-dot.webp' style={{width:"12px",height:"12px"}}/>
							</span>
								<span className='game-fonts'>
								FLUSH
								</span>
							</Col>
							<Row className={(scoreName === 'FLUSH') ? ' active col-6 ' : ' col-6 '}>
								<span className="text-warning">1.6x - {forceSatoshiFormat(this.state.amount * 1.6)}</span>
							</Row>
							</Row>
						</Row>
					</Row>
					<Row md={5} lg={5} sm={5} className={'col-12 col-sm-5 col-md-5 '} style={{margin:"1px"}} >
						<Row>
						<Row sm={12} md={12} style={{width:"100%",backgroundColor:"#222328",padding:" 7px 0px"}}>
						
							<Col style={{display:"flex",alignItems:"center",gap:"3px"}} className={(scoreName === 'STRAIGHT') ? ' active col-6 ' : ' col-6'}>
							<span>
							<img src='/assets/images/poker-table-dot.webp' style={{width:"12px",height:"12px"}}/>
							</span>
								<span className='game-fonts'>STRAIGHT</span>
							</Col>
							<Row className={(scoreName === 'STRAIGHT') ? ' active col-6 ' : ' col-6'}>
								<span className="text-warning">1.4x - {forceSatoshiFormat(this.state.amount * 1.4)}</span>
							</Row>
							</Row>

							<Row sm={12} md={12} style={{width:"100%",backgroundColor:"#222328",padding:" 7px 0px"}}>
							<Col style={{display:"flex",alignItems:"center",gap:"3px"}} className={(scoreName === 'THREE OF A KIND') ? ' active col-6 ' : ' col-6'}>
							<span>
							<img src='/assets/images/poker-table-dot.webp' style={{width:"12px",height:"12px"}}/>
							</span>
								<span className='game-fonts'>
								3 OF A KIND
								</span>
							</Col>
							<Row className={(scoreName === 'THREE OF A KIND') ? ' active col-6 ' : ' col-6 '}>
								<span className="text-warning">1.3x - {forceSatoshiFormat(this.state.amount * 1.3)}</span>
							</Row>
							</Row>

							<Row sm={12} md={12} style={{width:"100%",backgroundColor:"#222328",padding:" 7px 0px"}}>
							<Col style={{display:"flex",gap:"3px",alignItems:"center"}} className={(scoreName === 'TWO PAIR') ? ' active col-6 ' : ' col-6'}>
							<span>
							<img src='/assets/images/poker-table-dot.webp' style={{width:"12px",height:"12px"}}/>
							</span>
							<span className='game-fonts'>
							2 PAIRS
							</span>
								
							</Col>
							<Row className={(scoreName === 'TWO PAIR') ? ' active col-6 ' : ' col-6'}>
								<span className="text-warning">1.2x - {forceSatoshiFormat(this.state.amount * 1.2)}</span>
							</Row>
							</Row>

							<Row sm={12} md={12} style={{width:"100%",backgroundColor:"#222328",padding:" 7px 0px"}}>
							<Col style={{display:"flex",gap:"3px",alignItems:"center"}} className={(scoreName === 'JACKS OR BETTER') ? ' active col-6 ' : ' col-6'}>
							<span>
							<img src='/assets/images/poker-table-dot.webp' style={{width:"12px",height:"12px"}}/>
							</span>
								<span className='game-fonts'>JACKS OR BETTER</span>
							</Col>
							<Row className={(scoreName === 'JACKS OR BETTER') ? ' active col-6 ' : ' col-6'}>
								<span className="text-warning">1.1x - {forceSatoshiFormat(this.state.amount * 1.1)}</span>
							</Row>
							</Row>

							<Row sm={12} md={12} style={{width:"100%",backgroundColor:"#222328",padding:" 7px 0px"}}>
							<Col style={{display:"flex",gap:"3px",alignItems:"center"}} className={(scoreName === 'NOTHING') ? ' active col-6 ' : ' col-6'}>
							<span>
							<img src='/assets/images/poker-table-dot.webp' style={{width:"12px",height:"12px"}}/>
							</span>
								<span className='game-fonts'>
								NOTHING
								</span>
							</Col>
							<Row className={(scoreName === 'NOTHING') ? ' active col-6 ' : ' col-6'}>
								<span className="text-warning">0x - {forceSatoshiFormat(0)}</span>
							</Row>
							</Row>
						</Row>
					</Row>
				</Row>
			

			</>
		);
	}

}

export default Table
